export default __webpack_public_path__ + "static/media/battery-75.1d07296c.svg";